import { init, type EChartsType } from 'echarts'
import type { VoteEntry } from '@/types'

const COLORS = ['#ff6b6b', '#feca57', '#48dbfb'] as const

/**
 * Wraps an ECharts instance for the stacked vote bar.
 * Lifecycle: init() → update(top3) → destroy()
 */
export class VoteChart {
  private chart: EChartsType | null = null
  private container: HTMLElement | null = null

  init(container: HTMLElement): void {
    this.chart?.dispose()
    this.container = container
    this.chart = init(container)
    this.update([])
  }

  update(top3: VoteEntry[]): void {
    if (!this.chart) return

    if (top3.length === 0) {
      this.container?.style.setProperty('visibility', 'hidden')
      this.chart.clear()
      return
    }

    this.container?.style.setProperty('visibility', 'visible')

    const total = top3.reduce((s, d) => s + d.count, 0)

    this.chart.setOption({
      animation: true,
      grid: { left: 10, right: 10, top: 0, bottom: 0 },
      xAxis: { type: 'value', max: total, show: false },
      yAxis: { type: 'category', data: [''], show: false },
      series: top3.map((entry, i) => ({
        name: String(entry.number),
        type: 'bar',
        stack: 'total',
        data: [entry.count],
        barWidth: 28,
        itemStyle: {
          borderRadius:
            i === 0
              ? [6, 0, 0, 6]
              : i === top3.length - 1
                ? [0, 6, 6, 0]
                : 0,
          color: COLORS[i],
          shadowBlur: 8,
          shadowColor: COLORS[i] + 'aa',
        },
        label: {
          show: true,
          position: 'inside',
          formatter: () => `${entry.number}  (${entry.count})`,
          fontFamily: 'Nunito, sans-serif',
          fontWeight: 'bold',
          fontSize: 12,
          color: '#fff',
        },
      })),
    })
  }

  resize(): void {
    this.chart?.resize()
  }

  destroy(): void {
    this.chart?.dispose()
    this.chart = null
    this.container = null
  }
}
